import React from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'

export default function BranchPagination({ page, pageCount, totalCount, perPage, onChange }) {
  if (pageCount <= 1) return null

  const pages = []
  const start = Math.max(1, page - 2)
  const end = Math.min(pageCount, page + 2)

  for (let i = start; i <= end; i++) {
    pages.push(i)
  }

  return (
    <div className='branch-pagination'>
      <button disabled={page <= 1} onClick={() => onChange(page - 1)}>
        <FiChevronLeft />
      </button>

      {start > 1 && (
        <>
          <button onClick={() => onChange(1)}>1</button>
          {start > 2 && <span className='page-info'>...</span>}
        </>
      )}

      {pages.map(p => (
        <button key={p} className={p === page ? 'active' : ''} onClick={() => onChange(p)}>
          {p}
        </button>
      ))}

      {end < pageCount && (
        <>
          {end < pageCount - 1 && <span className='page-info'>...</span>}
          <button onClick={() => onChange(pageCount)}>{pageCount}</button>
        </>
      )}

      <button disabled={page >= pageCount} onClick={() => onChange(page + 1)}>
        <FiChevronRight />
      </button>

      <span className='page-info'>{totalCount} items</span>
    </div>
  )
}
